import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';
import { ActionResponse } from 'types/ActivationOrderTypes';

export type archiveActivationOrderDataType = {
  id: string;
  successCallback?: (result: ActionResponse) => void;
  errorCallback?: Function;
  resultKey?: string;
};

export default ({
  id,
  successCallback,
  errorCallback,
  resultKey = 'archiveActivationOrderData',
}: archiveActivationOrderDataType) =>
  requestAsync({
    url: endpoints.getAOActionArchiveUrl(id),
    transform: (response: ActionResponse) => ({
      [resultKey]: response,
    }),
    queryKey: `${endpoints.getAOActionArchiveUrl(id)}`,
    body: {},
    options: {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
